<form class="needs-validation" [formGroup]="form">
  <div class="row">
    @for (field of fields; track field.name) {
      @if ((form | subfieldVisible: field | async) && !field.hiddenField) {
        <app-dynamic-field
          [ngClass]="field | itemClass"
          [field]="field"
          [subFields]="fieldsByParent[field.name]"
          [control]="form | formControl: field.name"
          [disabled]="disabled"
          [customColumnTpls]="customColumnTpls"
          [markAsTouched]="markAsTouched"
          (onUpdate)="onUpdate.emit()"
        ></app-dynamic-field>
      }
    }
  </div>
</form>
